"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PetCard = void 0;
var react_1 = __importStar(require("react"));
var index_css_1 = __importDefault(require("./index.css"));
var edit_png_1 = __importDefault(require("../../static/images/edit.png"));
var link_1 = require("../../ui/link");
var texts_1 = require("../../ui/texts");
var react_router_dom_1 = require("react-router-dom");
var recoil_1 = require("recoil");
var editPet_1 = require("../../hooks/editPet");
var reportar_modal_1 = require("../../components/reportar-modal");
function PetCard(props) {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var setEditPetId = (0, recoil_1.useSetRecoilState)(editPet_1.editPetId);
    var _a = (0, react_1.useState)(false), showModal = _a[0], setShowModal = _a[1];
    function handleEdit() {
        setEditPetId(props.petId);
        navigate("/editar-mascota");
    }
    function escape(e) {
        if (e.key == "Escape") {
            setShowModal(false);
        }
    }
    function handleReport() {
        setShowModal(true);
    }
    return (react_1.default.createElement("div", { className: index_css_1.default["pet-card-container"] },
        react_1.default.createElement("img", { className: index_css_1.default["image-pet"], src: props.imageUrl, alt: props.name }),
        react_1.default.createElement("div", { className: index_css_1.default["datos-pet"] },
            react_1.default.createElement("div", null,
                react_1.default.createElement(texts_1.SubtitleBold, null, props.name),
                react_1.default.createElement("p", { className: index_css_1.default["pet-location"] }, props.city + ", " + props.region)),
            props.editable ? (react_1.default.createElement(EditBtn, { onClick: handleEdit })) : (react_1.default.createElement(ReportLink, { onClick: handleReport }))),
        showModal && (react_1.default.createElement("div", { className: index_css_1.default.mask, onClick: function () {
                setShowModal(false);
            } })),
        showModal && (react_1.default.createElement("div", { onKeyDown: escape, className: index_css_1.default["modal-container"] },
            react_1.default.createElement(reportar_modal_1.ReportarModal, { setShow: setShowModal, contact: props.contact, id: props.petId.toString(), name: props.name })))));
}
exports.PetCard = PetCard;
function EditBtn(_a) {
    var onClick = _a.onClick;
    return (react_1.default.createElement("img", { onClick: onClick, className: index_css_1.default["edit-btn"], src: edit_png_1.default, alt: "edit-pet" }));
}
function ReportLink(_a) {
    var onClick = _a.onClick;
    return (react_1.default.createElement("div", { className: index_css_1.default["report-link"] },
        react_1.default.createElement(link_1.LinkButton, { onClick: onClick }, "REPORTAR INFORMACION")));
}
